import React from 'react';
import { GridColDef, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarQuickFilter } from '@mui/x-data-grid';

export const tagInfoColumns: GridColDef[] = [
  { field: 'attribute', headerName: 'Attribute', flex: 1 },
  { field: 'value', headerName: 'Value', flex: 1 }
];


export function TagInfoCustomToolbar(): JSX.Element {
  return (
    <GridToolbarContainer>
      <div className="project-grid-toolbar-title">Attributes</div>

      <div className="project-grid-toolbar-filters">
        <GridToolbarQuickFilter />
        <GridToolbarDensitySelector />
      </div>
    </GridToolbarContainer>
  );
}

